import { DialogService, DialogRef } from '@app/ui/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ModalMessagesComponent } from '../../components/modal-messages/modal-messages.component';

const MENSAJE_GENERICO =
  'No se pudo completar su requerimiento. Por favor intente más tarde.<br> Si el problema persiste, por favor contactar a soporte técnico.';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private dialog = inject(DialogService);

  /** Modal de error en pantalla, si hay alguno. */
  private abierto: DialogRef | null = null;

  /** Reporta el error de una llamada a la API. */
  received(err: any): void {
    this.mostrarError(this.mensajeDeError(err));
  }

  /**
   * Muestra un solo modal de error a la vez.
   *
   * Una pantalla que carga varios recursos en paralelo abría un modal por
   * petición fallida y había que cerrarlos de a uno. Mientras haya uno abierto
   * los siguientes se descartan: el usuario ya está viendo que algo falló, y el
   * primer mensaje es el del error que originó la cascada.
   *
   * Es el punto único de entrada: si un componente abre su propio modal de
   * error, ese queda fuera del descarte.
   */
  mostrarError(mensaje?: string): void {
    if (this.abierto) return;

    this.abierto = this.dialog.open(ModalMessagesComponent, {
      data: {
        tipo: 'error',
        message: mensaje?.trim() || MENSAJE_GENERICO,
      },
    });

    this.abierto.afterClosed().subscribe(() => {
      this.abierto = null;
    });
  }

  /**
   * Mensaje de negocio del backend. `mensaje` es el campo de GenericException;
   * `message` cubre las excepciones estándar de Nest (401/403 de los guards),
   * que antes caían en el default `''` y dejaban el modal en blanco.
   */
  private mensajeDeError(err: any): string {
    if (err instanceof HttpErrorResponse) {
      return err.error?.mensaje || err.error?.message || MENSAJE_GENERICO;
    }
    return err?.message || MENSAJE_GENERICO;
  }
}
